import { useCallback } from 'react'
import { legacyHelpPath } from '../components/HelpCenter/helpTree'
import { FEATURE_FLAGS } from './featureFlagKeys'
import { useFeatureFlag } from './useFeatureFlags'

// Help links in the app are written as addresses of the old help center. While
// the in-app help center is switched on they lead there instead; switched off,
// they stay as written. Only for pages behind the login: the in-app help center
// cannot be read without one.
export function useHelpLink(): (url: string) => string {
  const inApp = useFeatureFlag(FEATURE_FLAGS.HELP_CENTER_IN_APP_ENABLED)
  return useCallback(
    (url: string) => (inApp ? (legacyHelpPath(url) ?? url) : url),
    [inApp]
  )
}
